const API = 'https://knowyoursteam.djaw.uk/'

export interface Game {
    n: string,
    m: number,
    i: number
}

export const getGames = async (username:string) =>{
   const response = await fetch(API+'games/'+username, {method: 'GET' })
    const json = await response.json();
    return json
}


export interface postStatProps {
    correct: boolean
}

export const postStat = async (data:postStatProps)=>  await fetch(API+'stats/',{
        method:'POST', 
        headers: {
            "Content-Type": "application/json",
        }, 
        body: JSON.stringify(data)})
  
export const getStats =  async () =>{
   const response = await fetch(API+'stats/', {method: 'GET' })
    const json = await response.json();
    return json
}
 